<template>

<div style="padding-top: 8px;">
    <div class="sub-small">
        {{ $moment(params.data.created_at).format('MMMM D, YYYY') }}
    </div>
    <div class="small">
        {{ $moment(params.data.created_at).format('hh:mm A')}}
    </div>

</div>

</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
.small {
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 18px;
  letter-spacing: 0.107143px;
  color: #2c2c2c;
  text-overflow: ellipsis;
  overflow: hidden;
  width: 185px;
  white-space: nowrap;
}

.sub-small {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 21px;
  letter-spacing: 0.107143px;
  color: #2c2c2c;
}

</style>